import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import gameimage from './Assets/Xianhe New Assets/natal-assets/latestwheel.png';
import { 
  blessedAmulets, 
  fortuneSticks, 
  lifeForecast, 
  selfMastery, 
  natalArrow, 
  fs,
  natalTitleFooter 
} from "./Assets/Xianhe New Assets/natal-assets";
import step1 from "./Assets/Xianhe New Assets/fortune-sticks-icons/touch 2.png";
import step2 from "./Assets/Xianhe New Assets/fortune-sticks-icons/spin.png";
import step3 from "./Assets/Xianhe New Assets/fortune-sticks-icons/Union.png";

const FeatureIcon = ({ image, title, description, active }) => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    width: '220px',
    opacity: active ? 1 : 0.7,
    transition: 'opacity 0.3s ease',
    padding: '0 10px'
  }}>
    <div style={{
      width: '40px',
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '12px'
    }}>
      <img src={image} alt={title} style={{ width: '40px', height: '40px', objectFit: 'contain' }} />
    </div>
    <h4 style={{ 
      color: '#fff', 
      fontFamily: "'PlayfairDisplay', serif", 
      margin: '0 0 8px 0', 
      fontSize: '18px', 
      fontWeight: 'bold' 
    }}>{title}</h4>
    <p style={{ 
      color: 'rgba(255,255,255,0.7)', 
      fontSize: '13px', 
      margin: 0, 
      lineHeight: '1.5',
      maxWidth: '180px'
    }}>{description}</p>
  </div>
);

const DottedLine = ({ isMobile }) => (
  <div style={{ 
    display: 'flex', 
    alignItems: 'center', 
    height: '40px',
    margin: '0 -45px',
    zIndex: 1
  }}>
    {!isMobile && <img src={natalArrow} alt="arrow" style={{ width: '130px', height: '8px', opacity: 1 }} />}
  </div>
);

const JourneySection = ({ isMobile, t }) => (
  <div style={{
    width: '100%',
    maxWidth: '1400px',
    margin: '0px auto 10px auto',
    textAlign: 'center',
    color: '#DFBD69',
    position: 'relative',
    zIndex: 2,
    transform: 'scale(0.85)',
    transformOrigin: 'top center'
  }}>
    <h1 style={{ 
      fontFamily: "'PlayfairDisplay', serif", 
      fontSize: isMobile ? '36px' : '54px', 
      fontWeight: '700',
      marginBottom: '15px',
      color: '#DFBD69'
    }}>
      {t("natalChart.topheader", "Your Journey starts here.")}
    </h1>
    <p style={{ 
      fontFamily: "'DMSans', sans-serif", 
      fontSize: isMobile ? '16px' : '20px', 
      marginBottom: '60px',
      opacity: 0.9,
      color: '#fff'
    }}>
      {t("natalChart.topheader2", "Explore your tools for clarity, guidance and growth:")}
    </p>

    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'flex-start',
      gap: isMobile ? '10px' : '0px',
      flexWrap: isMobile ? 'wrap' : 'nowrap',
      padding: '0 20px',
      width: '100%',
      overflowX: isMobile ? 'visible' : 'hidden'
    }}>
      <FeatureIcon 
        image={step1} 
        // title={t("natalChart.subheader1", "Life Forecast")} 
        description={t("natalChart.subheader1desc")}
        active={true}
      />
      <DottedLine isMobile={isMobile} />
      <FeatureIcon        
        image={step2} 
        // title={t("natalChart.subheader2", "Fortune Sticks")} 
        description={t("natalChart.subheader2desc")}
        active={true}
      />
      <DottedLine isMobile={isMobile} />
      <FeatureIcon 
        image={step3} 
        // title={t("natalChart.subheader3", "Self-Mastery")} 
        description={t("natalChart.subheader3desc")}
        active={true}
      />
      {/* <DottedLine isMobile={isMobile} />
      <FeatureIcon 
        image={blessedAmulets} 
        title={t("natalChart.subheader4", "Blessed Amulets")} 
        description={t("natalChart.subheader4desc")}
        active={true}
      /> */}
    </div>

    {/* Decorative Flourish */}
    <div style={{ 
      marginTop: '40px', 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      opacity: 1
    }}>
      <img src={natalTitleFooter} alt="flourish" style={{ width: isMobile ? '280px' : '450px', height: 'auto' }} />
    </div>
  </div>
);

const FortuneStick = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [modalVisible, setModalVisible] = useState(false);
  const [gameResult, setGameResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userQuestion, setUserQuestion] = useState('');
  const [availableSticks, setAvailableSticks] = useState(null);
  const [isUnlimited, setIsUnlimited] = useState(false);
  const [custId, setCustId] = useState(null);
  const [shaking, setShaking] = useState(false);
  const [alertMessage, setAlertMessage] = useState(null);
  const [submittedQuestion, setSubmittedQuestion] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isAuthenticated =
    localStorage.getItem('isLoggedIn') === 'true' &&
    !!localStorage.getItem('userID');
  useEffect(() => {
    const userId = localStorage.getItem('userID');
    if (userId) {
      setCustId(userId);
      fetchAvailableSticks(userId);
    }
  }, []);

  const fetchAvailableSticks = async (userId) => {
    try {
      const response = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/Game/GetAvailableStick?CustId=${userId}`
      );
      const data = await response.json();
      
      if (data.AvailableStick === 'Unlimited') {
        setIsUnlimited(true);
        setAvailableSticks('Unlimited');
      } else {
        setIsUnlimited(false);
        setAvailableSticks(parseInt(data.AvailableStick) || 0);
      }
    } catch (error) {
      console.error('Error fetching available sticks:', error);
      setAvailableSticks(0);
    }
  };

  const fetchGameResult = async (question) => {
    try {
      setLoading(true);
      const response = await fetch(
        'https://xianhefairy.com/LotusFairy_API/api/Game/FortuneAnswer',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ CustID: custId, Question: question }),
        }
      );
      const data = await response.json();
      console.log('FortuneAnswer response:', data);
      const result = Array.isArray(data) ? data[0] : data;
      if (result && result.Answer) {
        setGameResult(result);
      } else {
        setGameResult({
          Answer: t('fortuneStick.tryAgain'),
          Message: '请重试',
        });
      }
    } catch (error) {
      console.error('Error fetching game result:', error);
      setGameResult({
        CATEGORY: '错误',
        REMARKS_A: '网络错误，请重试',
        REMARKS_B: 'Network error, please try again',
      });
    } finally {
      setLoading(false);
    }
  };

  const MIN_QUESTION_LENGTH = 4;

  const performShake = async () => {
    const question = userQuestion.trim();
    setSubmittedQuestion(question);
    setUserQuestion('');
    setShaking(true);
    await new Promise((resolve) => setTimeout(resolve, 400));
    setShaking(false);
    await fetchGameResult(question);
    if (!isUnlimited && typeof availableSticks === 'number') {
      setAvailableSticks((prev) => prev - 1);
    }
    setModalVisible(true);
  };

  const startShake = () => {
    if (!isAuthenticated) {
      setAlertMessage(t('fortuneStick.loginRequired'));
      return;
    }
    if (userQuestion.trim().length < MIN_QUESTION_LENGTH) {
      setAlertMessage(t('fortuneStick.alertMinLength'));
      return;
    }
    if (!isUnlimited && availableSticks === 0) {
      setAlertMessage(t('fortuneStick.alertNoSticks'));
      return;
    }
    performShake();
  };

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes shake {
          0%   { transform: translateX(0); }
          20%  { transform: translateX(-10px); }
          40%  { transform: translateX(10px); }
          60%  { transform: translateX(-10px); }
          80%  { transform: translateX(10px); }
          100% { transform: translateX(0); }
        }
        .fortune-shake { animation: shake 0.4s ease; }
      `}</style>

      {alertMessage && (
        <div style={styles.alertOverlay}>
          <div style={styles.alertBox}>
            <p style={styles.alertText}>{alertMessage}</p>
            <button style={styles.alertButton} onClick={() => setAlertMessage(null)}>
              {t('fortuneStick.ok')}
            </button>
          </div>
        </div>
      )}

      <div style={styles.header}>
        <button style={styles.backButton} onClick={() => navigate('/chart')}>
          &#8592;
        </button>
      </div>

      <div style={styles.contentWrapper}>
        <JourneySection isMobile={isMobile} t={t} />
        
        <div style={styles.gameSection}>
          <div style={styles.imageWrapper} onClick={startShake}>
            <img
              src={gameimage}
              alt={t('fortuneStick.title')}
              className={shaking ? 'fortune-shake' : ''}
              style={styles.gameImage}
            />
          </div>

          <div style={styles.infoContainer}>
            <span style={styles.headerTitle}>{t('fortuneStick.title')}</span>
            <span style={styles.sticksCount}>
              {t('fortuneStick.sticks')} {isAuthenticated ? availableSticks !== null ? availableSticks : '...' : '...'}
            </span>
            {isAuthenticated && !isUnlimited && availableSticks === 0 && (
              <div style={styles.noSticksContainer}>
                <p style={styles.noSticksMessage}>{t('fortuneStick.noSticksMessage')}</p>
                <button style={styles.shopButton} onClick={() => navigate('/shop', { state: { tab: 'wheel' } })}>
                  {t('fortuneStick.goToShop')}
                </button>
              </div>
            )}
          </div>

          <div style={styles.inputContainer}>
            <textarea
              style={{
                ...styles.textInput,
                opacity: isAuthenticated ? 1 : 0.5,
                cursor: isAuthenticated ? 'text' : 'not-allowed',
              }}
              placeholder={!isAuthenticated ? t('fortuneStick.loginRequired') : t('fortuneStick.placeholder')}
              value={userQuestion}
              onChange={(e) => setUserQuestion(e.target.value)}
              rows={4}
              disabled={!isAuthenticated}
            />
            <button style={styles.shakeButton} onClick={startShake} disabled={loading || !custId}>
              {loading ? t('fortuneStick.loading') : t('fortuneStick.shakeButton')}
            </button>
          </div>
        </div>
      </div>

      {modalVisible && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <h2 style={styles.modalTitle}>{t('fortuneStick.yourFortune')}</h2>
            {submittedQuestion && (
              <p style={styles.remarksB}>{submittedQuestion}</p>
            )}
            {gameResult && (
              <p style={styles.remarksA}>{gameResult.Answer}</p>
            )}
            <button
              style={styles.closeButton}
              onClick={() => setModalVisible(false)}
            >
              {t('fortuneStick.close')}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: 'transparent',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '60px 20px 40px 20px',
    fontFamily: "'DMSans', sans-serif",
    gap: '10px',
    position: 'relative',
    overflowX: 'hidden',
  },
  contentWrapper: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: '1400px',
  },
  gameSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: '600px',
  },
  header: {
    width: '100%',
    maxWidth: '1200px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '10px',
    position: 'absolute',
    top: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    padding: '0 20px',
    boxSizing: 'border-box',
    zIndex: 10,
  },
  backButton: {
    background: 'transparent',
    border: 'none',
    color: '#dfbd69',
    fontSize: '24px',
    cursor: 'pointer',
  },
  headerTitle: {
    color: '#dfbd69',
    fontSize: '22px',
    fontWeight: 'bold',
    fontFamily: "'PlayfairDisplay', serif",
  },
  sticksCount: {
    color: '#dfbd69',
    fontSize: '14px',
  },
  noSticksContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
    marginTop: '6px',
  },
  noSticksMessage: {
    color: 'rgba(255,255,255,0.75)',
    fontSize: '13px',
    textAlign: 'center',
    margin: 0,
    maxWidth: '320px',
    lineHeight: '1.5',
    fontFamily: "'DMSans', sans-serif",
  },
  shopButton: {
    padding: '8px 22px',
    backgroundColor: 'transparent',
    color: '#dfbd69',
    border: '1px solid #dfbd69',
    borderRadius: '8px',
    fontSize: '13px',
    cursor: 'pointer',
    fontFamily: "'DMSans', sans-serif",
  },
  imageWrapper: {
    cursor: 'pointer',
    marginBottom: '20px',
    filter: 'drop-shadow(0 0 18px rgba(223, 189, 105, 0.6))',
    transition: 'filter 0.3s ease',
    position: 'relative',
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '30px',
    textAlign: 'center',
  },
  gameImage: {
    width: '235px',
    height: '510px',
    objectFit: 'contain',
  },
  inputContainer: {
    width: '100%',
    maxWidth: '520px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  textInput: {
    padding: '12px',
    fontSize: '15px',
    borderRadius: '10px',
    border: '1px solid #dfbd69',
    backgroundColor: 'rgba(10, 3, 30, 0.6)',
    color: '#fff',
    resize: 'none',
    outline: 'none',
    fontFamily: "'DMSans', sans-serif",
  },
  shakeButton: {
    padding: '14px',
    backgroundColor: '#dfbd69',
    color: '#212123',
    border: 'none',
    borderRadius: '10px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    boxShadow: '0 4px 15px rgba(223, 189, 105, 0.5)',
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.7)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000,
  },
  modalContent: {
    backgroundColor: '#0A031E',
    borderRadius: '16px',
    padding: '30px',
    maxWidth: '400px',
    width: '90%',
    textAlign: 'center',
    border: '1px solid #dfbd69',
  },
  modalTitle: {
    color: '#dfbd69',
    fontSize: '22px',
    marginBottom: '16px',
    fontFamily: "'PlayfairDisplay', serif",
  },
  remarksA: {
    color: '#fff',
    fontSize: '16px',
    marginBottom: '8px',
  },
  remarksB: {
    color: '#fff',
    fontSize: '14px',
    marginBottom: '20px',
  },
  closeButton: {
    padding: '10px 30px',
    backgroundColor: '#dfbd69',
    color: '#1a1100',
    border: 'none',
    borderRadius: '8px',
    fontSize: '15px',
    cursor: 'pointer',
  },
  alertOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10001,
  },
  alertBox: {
    backgroundColor: '#0A031E',
    borderRadius: '12px',
    padding: '24px',
    maxWidth: '340px',
    width: '90%',
    textAlign: 'center',
    border: '1px solid #dfbd69',
  },
  alertText: {
    color: '#fff',
    fontSize: '15px',
    marginBottom: '16px',
  },
  alertButton: {
    padding: '8px 24px',
    backgroundColor: '#dfbd69',
    color: '#1a1100',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    cursor: 'pointer',
  },
};

export default FortuneStick;